import { useEffect, useState } from 'react';
import TextLeft from '../../../../../../Assets/Lens/leftAllign.svg';
import TextCenter from '../../../../../../Assets/Lens/centerAllign.svg';
import TextRight from '../../../../../../Assets/Lens/rightAllign.svg';
import TextFill from '../../../../../../Assets/Lens/backgroundA.svg';
import Plus from '../../../../../../Assets/Lens/Add.svg';
import Minus from '../../../../../../Assets/Lens/Minus.svg';

import { useDispatch } from 'react-redux';
import { setEditSection } from '../../../../../../Features/lensSlice';
import colors from './colors';
// import { VideoContext } from '../../../../../../Context/VideoContext';

import { FFmpeg } from '@ffmpeg/ffmpeg';
// import { fetchFile } from '@ffmpeg/util';

//Store the ffmpeg instance
let ffmpeg;

function TextEdit() {
    const dispatch = useDispatch();

    // const video = useSelector((state) => state.lens.media.video);

    const [textAlign, setTextAlign] = useState('');
    const [textFill, setTextFill] = useState(false);
    const [textSize, setTextSize] = useState(12);
    const [textColor, setTextColor] = useState('#FFFFFF');

    // const { videoFile, setLoading, setVideoFile } = useContext(VideoContext);

    const handleCancel = () => {
        dispatch(setEditSection(null));
    }

    const handleAlignClick = (type) => {
        if(textAlign === type) {
            setTextAlign('');
        }
        else {
            setTextAlign(type);
        }
    }

    const handleTextFillButton = () => {
        setTextFill(!textFill);
    }

    const handlePlus = () => {
        setTextSize(textSize+1);
    }

    const handleMinus = () => {
        setTextSize(textSize-1);
    }

    const handleSelectTextColor = (color) => {
        setTextColor(color);
    }

    const [isScriptLoaded, setIsScriptLoaded] = useState(false);

    const handleConfirmText = async () => {
        dispatch(setEditSection(null));
    };

    useEffect(() => {
        const loadffmpeg = async () => {
            ffmpeg = new FFmpeg();
            await ffmpeg.load({ log: true });
            setIsScriptLoaded(true);
        }

        loadffmpeg();
        console.log(isScriptLoaded);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className='relative flex flex-col size-full p-4 bg-[#FFFFFF]'>
            <div className="flex flex-col gap-3">
                <div className="flex items-center justify-between">
                    <h1 className='font-medium text-[16px] leading-5 text-[#121212]'>Text</h1>

                    <button 
                        onClick={handleCancel} 
                        className='underline font-medium text-[14px] leading-5 text-[#1055EB]'
                    >Cancel</button>
                </div>

                <div className="flex items-center gap-5">
                    <button onClick={() => handleAlignClick('left')} className={`${textAlign === 'left' ? 'bg-main' : 'bg-[#EFEFEF]'} transition-all duration-300 ease-out size-8 rounded-full flex items-center justify-center`}>
                        <img className='size-6' src={TextLeft} alt="" />
                    </button>

                    <button onClick={() => handleAlignClick('center')} className={`${textAlign === 'center' ? 'bg-main' : 'bg-[#EFEFEF]'} transition-all duration-300 ease-out size-8 rounded-full flex items-center justify-center`}>
                        <img className='size-6' src={TextCenter} alt="" />
                    </button>

                    <button onClick={() => handleAlignClick('right')} className={`${textAlign === 'right' ? 'bg-main' : 'bg-[#EFEFEF]'} transition-all duration-300 ease-out size-8 rounded-full flex items-center justify-center`}>
                        <img className='size-6' src={TextRight} alt="" />
                    </button>

                    <button onClick={handleTextFillButton} className={`${textFill ? 'bg-main' : 'bg-[#EFEFEF]'} transition-all duration-300 ease-out size-8 rounded-full flex items-center justify-center`}>
                        <img className='size-6' src={TextFill} alt="" />
                    </button>
                </div>

                <textarea className='outline-none h-[10rem] px-3 py-4 bg-[#F5F5F5] font-normal text-base text-[#121212] placeholder:text-[#666666] rounded-[9px] border border-[#EAEAEA]' placeholder='Add text' name="" id="" />

                <div className="flex items-center gap-3">
                    <button onClick={handlePlus} className='size-6 flex items-center justify-center rounded-full bg-[#F5F5F5]'>
                        <img src={Plus} alt="" />
                    </button>

                    <div className="w-20 text-center px-3 py-[11px] bg-[#FFFFFF] rounded-[9px] border border-[#666666]">
                        <p className='font-normal text-base text-[#121212]'>{textSize}</p>
                    </div>

                    <button onClick={handleMinus} className='size-6 flex items-center justify-center rounded-full bg-[#F5F5F5]'>
                        <img src={Minus} alt="" />
                    </button>
                </div>

                <div className="flex gap-1 overflow-x-scroll no-scrollbar">
                    {colors.map(color => {
                        return (
                            <button onClick={() => handleSelectTextColor(color)} className={`size-11 outline-none ${textColor === color ? 'p-[6px]' : 'p-[10px]'}`} key={color}>
                                <div className={`${textColor === color ? 'size-8 rounded-lg border border-main' : 'size-6 rounded-md'}`} style={{ backgroundColor: color }}></div>
                            </button>
                        )
                    })}
                </div>
            </div>

            <div className="absolute bottom-0 left-0 w-full px-4 py-3 bg-[#FFFFFF] border-t border-[#EAEAEA]">
                <button onClick={handleConfirmText} className='w-full px-4 py-[6px] rounded-md bg-main hover:bg-[#14ED6E] font-semibold text-[14px] leading-[26px] text-[#121212]'>Confirm Text</button>
            </div>
        </div>
    );
}

export default TextEdit;
